// extracted by mini-css-extract-plugin
module.exports = {"uploadBigSquare":"UploadBigSquare_uploadBigSquare__1_3Gx","icon":"UploadBigSquare_icon__10jpI"};